export default __webpack_public_path__ + "static/clean-ingredients_real-people_Sage-E-1cec416f42a9afff9a7e373f49d6ace5.png";